import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PagesContext } from '../store/PagesContext';

import OList from 'components/Lists/OList';

const IsoC = ({ setCurrentPage }) => {
  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage('isoB'), []);

  const optionOneHandler = () => setCurrentPage('isoE');
  const optionTwoHandler = () => setCurrentPage('isoF');
  const optionThreeHandler = () => setCurrentPage('isoG');

  return (
    <div className='mw-700 m-auto py-sm-5'>
      <h1 className='page-heading text-center mb-5'>Great! How long do you intend to hold onto your incentivized shares?</h1>

      <OList>
        <li onClick={optionOneHandler}>I intend to sell my shares the same calendar year as exercising my options.</li>
        <li onClick={optionTwoHandler}>I intend to sell my shares within 12 months of exercising, but in a different calendar year. </li>
        <li onClick={optionThreeHandler}>
          I intend to sell my shares more than 1 year after exercising and more than 2 years after my grant date.
        </li>
      </OList>
    </div>
  );
};

IsoC.propTypes = {
  setCurrentPage: PropTypes.func
};

export default IsoC;
